import { ThemeColorCallback } from '@recruit-robin/robin-theme/web-styles';
import { useStyles } from './Ellipse.styles';

const defaultColor: ThemeColorCallback = (colors) => colors.neutral.variant[100];

export const Ellipse = ({ color = defaultColor }: { color?: ThemeColorCallback }) => {
  const classes = useStyles({ color });

  return <div css={classes.ellipse} />;
};
